import styled from 'styled-components';

export const StyledFieldset = styled.fieldset`
  margin-bottom: ${({ theme, $removeMarginBottom }) =>
    $removeMarginBottom ? 0 : theme.spacing.standard};
`;

export const Description = styled.p`
  margin-bottom: ${({ theme }) => theme.spacing.standard};
`;
